import { useMemo } from "react";
import useUser from "../../api/api-hooks/auth/useUser";

const UserActivityHeader = ({ noWorkspaces }: { noWorkspaces: boolean }) => {
  const { user, userLoading } = useUser();

  const userFirstName = useMemo(() => {
    if (!userLoading && !user?.Name) return null;

    if (typeof user?.Name !== "string") return null;

    const firstName = user.Name?.split?.(" ")?.[0];

    if (/^[a-zA-Z]/.test(firstName)) {
      return firstName;
    }
  }, [user?.Name, userLoading]);

  return (
    <div className="ml-2 ml-sm-0">
      <h2 className="mb-1 text-dark">
        {userFirstName ? `Hi ${userFirstName}!` : "Welcome!"}{" "}
      </h2>
      <h3 className="font-weight-500">
        {noWorkspaces
          ? "Create a workspace to get started"
          : "Pick back up where you left off"}
      </h3>
    </div>
  );
};

export default UserActivityHeader;
